export default __webpack_public_path__ + "static/splash-5bdca96691eacc91278448e73f0f38d4.svg";